<template>
    <div>
        <div class="flex flex-no-wrap gap-x-2 overflow-x-auto">
            <PaymentButton
                v-for="payment in defaultPayments" 
                :key="payment.key"
                :selected="value == payment.key"
                :hotKey="payment.hotKey"
                :imgSelected="payment.imgSelected"
                :imgNotSelected="payment.imgNotSelected"
                :label="payment.label"
                :helpKey="payment.helpKey"
                :disabled="!leftToPay"
                @click="$emit('input', payment.key)"
                @shortkey="$emit('input', payment.key)"
            />
        </div>
        <div class="flex flex-no-wrap gap-x-1 justify-center mt-4 whitespace-no-wrap overflow-x-auto">
            <transition-group name="list" tag="ul">

                <vs-chip v-for="amount in values" :key="amount.value || 0"
                    class="cursor-pointer transition-all duration-500 select-none hover:bg-primary hover:text-white active:bg-grey" style="min-width: 42px"
                    @click.native="setAmount(amount)"
                    :transparent="!amount.selected" color="primary">
                    <span v-if="amount.value">R$ {{ amount.value }}</span>
                    <span v-else>{{ amount.label }}</span>
                </vs-chip>

             </transition-group>

        </div>

        <transition name="faide">
            <div class="w-full text-center mt-3" v-if="isMoneySelected && changeValue">
                Troco para {{ changeValue.value }}: <b>{{ changeValue.change | currency }}</b>
            </div>
        </transition>
    </div>
</template>

<script>
    import PaymentButton from './PaymentButton.vue'

    const defaultPayments = [
        { key : 'money',        label : 'Dinheiro', helpKey : 'ALT + 1', hotKey : ['alt', '1'], imgSelected : require('@/assets/images/payment/money_white.png'), imgNotSelected : require('@/assets/images/payment/money_red.png') },
        { key : 'card_credit',  label : 'Crédito',  helpKey : 'ALT + 2', hotKey : ['alt', '2'], imgSelected : require('@/assets/images/payment/card_white.png'),  imgNotSelected : require('@/assets/images/payment/card_red.png') },
        { key : 'card_debit',   label : 'Débito',   helpKey : 'ALT + 3', hotKey : ['alt', '3'], imgSelected : require('@/assets/images/payment/card_white.png'),  imgNotSelected : require('@/assets/images/payment/card_red.png') },
        { key : 'picpay',      label : 'PicPay',   helpKey : 'ALT + 4', hotKey : ['alt', '4'], imgSelected : require('@/assets/images/payment/qr-code_white.png'),         imgNotSelected : require('@/assets/images/payment/qr-code.png') },
        { key : 'pix',          label : 'Pix',      helpKey : 'ALT + 5', hotKey : ['alt', '5'], imgSelected : require('@/assets/images/payment/pix_white.png'),         imgNotSelected : require('@/assets/images/payment/pix.png') },
        // { key : 'others',       label : 'Outros',   helpKey : 'ALT + 5', hotKey : ['alt', '5'], imgSelected : require('@/assets/images/payment/P_w.png'),         imgNotSelected : require('@/assets/images/payment/P.png') },
    ]

    const defaultValues = [
        { selected: false, value: 1 },
        { selected: false, value: 2 },
        { selected: false, value: 5 },
        { selected: false, value: 10 },
        { selected: false, value: 20 },
        { selected: false, value: 50 },
        { selected: false, value: 100 },
        { selected: false, label: 'Tudo (T)', hotKey: ['t'] },
    ]

    export default {
        components: { PaymentButton },

        props: {
            value: {
                type: String,
                default: 'card_credit'
            },
            leftToPay: Number,
            selectedValue: Number
        },

        data () {
            return {
                defaultPayments,
                defaultValues,
                changeValue: 0
            }
        },

        computed: {
            isMoneySelected () { return this.value === 'money' },
            values() {
                const  { defaultValues, isMoneySelected, leftToPay } = this;
                if (leftToPay <= 0)
                    return [];
                const list = defaultValues.filter(p => p.label || isMoneySelected 
                    || p.value <= leftToPay
                );
                // displays the 5 grater values
                return list.slice(Math.max(list.length - 5, 0));
            }
        },

        methods : {
            onClickMethod (type) {
                this.$emit('input', type);
            },
            setAmount (amount) {
                const { leftToPay } = this;
                this.showChangeTip(amount);
                this.$emit('amountInput', amount.value || leftToPay);
            },
            showChangeTip (amount) {
                const { leftToPay, isMoneySelected, selectedValue } = this;
                if (isMoneySelected && amount.value > leftToPay)
                    this.changeValue = { value: amount.value, change: amount.value - leftToPay }
                else if (selectedValue && isMoneySelected && amount.value > selectedValue) // for selected products
                    this.changeValue = { value: amount.value, change: amount.value - selectedValue }
                else
                    this.changeValue = null;
            }
        }
    }
</script>
<style scoped>

.list-enter-active, .list-leave-active {
  transition: transform 1s;
}

/* fade cannot be used! */ 
.faide-enter-active, .faide-leave-active {
  transition: opacity .5s;
}
.faide-enter, .faide-leave-to {
  opacity: 0;
}
</style>